import { z } from 'zod';

import { PickedCivilDayDto } from './civilDate';

export const StaffBusinessOverviewDayQueryDto = z
  .object({
    date: PickedCivilDayDto,
  })
  .strict();

export type ApiStaffBusinessOverviewDayQueryDto = z.infer<
  typeof StaffBusinessOverviewDayQueryDto
>;

export interface ApiStaffHomeMembershipPaymentRow {
  id: string;
  time: string;
  clientName: string | null;
  membershipName: string;
  amount: number;
  currency: string;
  paymentMethod: string;
}

export interface ApiStaffHomeBookingWalkinRow {
  id: string;
  time: string;
  clientName: string | null;
  amount: number;
  currency: string;
}

export interface ApiStaffHomeDeskSaleRow {
  id: string;
  time: string;
  clientName: string | null;
  productName: string;
  quantity: number;
  amount: number;
  currency: string;
  paymentMethod: string;
}

/**
 * The front-desk's daily payment lists (Daily stats tab) — one row per
 * individual payment/sale, not an aggregate, so staff can see and filter the
 * actual list rather than just a total. "Day pass" has no dedicated entity:
 * it is a `Membership` template with `duration = 1, durationUnit = 'DAYS'`.
 */
export interface ApiStaffBusinessOverviewDay {
  membershipPayments: ApiStaffHomeMembershipPaymentRow[];
  dayPasses: ApiStaffHomeMembershipPaymentRow[];
  bookingWalkinPayments: ApiStaffHomeBookingWalkinRow[];
  deskSales: ApiStaffHomeDeskSaleRow[];
}

export interface ApiStaffBusinessOverviewTrainer {
  trainerId: string;
  name: string;
  activeClientsCount: number;
  duePaymentsCount: number;
  scheduled: number;
  completed: number;
  missed: number;
}

export interface ApiStaffBusinessOverviewTrainersResponse {
  data: ApiStaffBusinessOverviewTrainer[];
}

export interface ApiTrainerDisconnectedClient {
  clientId: string;
  name: string | null;
  disconnectedAt: string | null;
}

export interface ApiTrainerDisconnectedClientsResponse {
  data: ApiTrainerDisconnectedClient[];
}
